import cc from 'classcat'
import React from 'react'

import { reactClass } from '../../utils'
import * as Styled from './styles'

export type LabelVariant = 'default' | 'notification' | 'success' | 'warning' | 'danger'

export type LabelProps = {
  children?: React.ReactNode
  className?: string
  variant?: LabelVariant
}

export const Label = ({ children, className, variant = 'default' }: LabelProps) => (
  <Styled.LabelContainer className={cc([className, reactClass('label')])} variant={variant}>
    {children}
  </Styled.LabelContainer>
)
